module.exports = __webpack_public_path__ + "img/ylhh.6034cb94.jpg";